export const setTooltipObj = (state, payload) => {
  state.tooltipObject = payload;
};

